import React from 'react';
import { Modal, TextContainer } from '@superops/ui-design-system';

function DeleteModal(props) {
  const handleDelete = () => {
    props.handleDeleteConfirmation();
    props.handleChange();
  };

  return (
    <div>
      <Modal
        activator={props.reference.current}
        open={props.active}
        onClose={props.handleChange}
        title={props.title || 'Delete confirmation'}
        primaryAction={{
          destructive: true,
          content: props.primaryBtn || 'Delete',
          onAction: handleDelete
        }}
        secondaryActions={[
          {
            content: props.cancelBtn || 'Cancel',
            onAction: props.handleChange
          }
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>{props.description || 'Are you sure?'}</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </div>
  );
}

export default DeleteModal;
